import { Record as record } from 'immutable';
import _ from 'lodash';

import { getDefaults, getResolvers } from '../../../../helpers/Records';
import { construct, resolve } from '../../../../helpers/LinkMapper';

const fieldSchema = {
    "id": [resolve.with(Number)],
    "title": [resolve.with(String)],
    "sendEmail": [resolve.with(Boolean)]
};

class Reason extends record(getDefaults(fieldSchema)) {

    static fromJSON (json = {}) {
        return construct(Reason, json, getResolvers(fieldSchema));
    }

    hasId () {
        return !_.isNil(this.id);
    }

    hasTitle () {
        return !_.isNil(this.title);
    }

}

export default Reason;
